var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.937,
    height: 12.663,
    viewBox: "0 0 13.937 12.663",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_56",
    "data-name": "Union 56",
    d: "M-1372.021,141.2a2.476,2.476,0,0,1,2.48-2.466,2.476,2.476,0,0,1,2.479,2.466,2.475,2.475,0,0,1-2.479,2.466A2.476,2.476,0,0,1-1372.021,141.2Zm1.2,0a1.278,1.278,0,0,0,1.285,1.271,1.278,1.278,0,0,0,1.283-1.271,1.278,1.278,0,0,0-1.283-1.271A1.279,1.279,0,0,0-1370.826,141.2Zm-9.123.9a1.043,1.043,0,0,1-1.05-1.032,1.042,1.042,0,0,1,1.05-1.032h4.583a1.042,1.042,0,0,1,1.05,1.032,1.043,1.043,0,0,1-1.05,1.032Zm-1.05-8.628a2.476,2.476,0,0,1,2.479-2.466,2.476,2.476,0,0,1,2.479,2.466,2.474,2.474,0,0,1-2.479,2.465A2.475,2.475,0,0,1-1381,133.466Zm1.194,0a1.279,1.279,0,0,0,1.284,1.271,1.279,1.279,0,0,0,1.285-1.271,1.28,1.28,0,0,0-1.285-1.272A1.28,1.28,0,0,0-1379.805,133.466Zm7.111.921a1.042,1.042,0,0,1-1.051-1.032,1.042,1.042,0,0,1,1.051-1.032h4.582a1.042,1.042,0,0,1,1.05,1.032,1.042,1.042,0,0,1-1.05,1.032Z",
    transform: "translate(1381 -131)",
    fill: "#1b2737"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/Filter.eb29308ca44d0a5e86874c87605a5e52.svg";
export { ForwardRef as ReactComponent };